/* SoraBazaar theme JS — vanilla, no dependencies */
(function () {
  "use strict";
  var T = window.theme || {};
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";

  /* ---------- money ---------- */
  function formatMoney(cents) {
    cents = Number(cents) || 0;
    var fmt = T.moneyFormat || "&#8377;{{amount}}";
    var value = (cents / 100).toLocaleString("en-IN", { minimumFractionDigits: cents % 100 === 0 ? 0 : 2, maximumFractionDigits: 2 });
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/g, value);
  }
  window.formatMoney = formatMoney;

  /* ---------- sticky header ---------- */
  var header = document.querySelector(".site-header");
  if (header) {
    var onScroll = function () { header.classList.toggle("scrolled", window.scrollY > 12); };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ---------- mobile menu ---------- */
  document.addEventListener("click", function (e) {
    var t = e.target.closest("[data-menu-toggle]");
    if (t) { var m = document.querySelector(".mobile-menu"); if (m) m.classList.toggle("open"); }
  });

  /* ---------- scroll reveal ---------- */
  if (!document.documentElement.classList.contains("no-reveal") && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    document.querySelectorAll("[data-reveal]").forEach(function (el) { io.observe(el); });
  }

  /* ---------- toast ---------- */
  var toast = document.getElementById("toast");
  var toastTimer;
  function showToast(name) {
    if (!toast) return;
    var txt = toast.querySelector(".toast-text");
    if (txt) txt.innerHTML = "Added <strong>" + name + "</strong> to cart";
    toast.classList.add("on");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove("on"); }, 2600);
  }

  /* ---------- cart drawer ---------- */
  var drawer = document.getElementById("cart-drawer");
  var scrim = document.getElementById("drawer-scrim");
  var useDrawer = T.cartDrawer !== false;

  function openDrawer() { if (drawer) { drawer.classList.add("on"); if (scrim) scrim.classList.add("on"); document.body.style.overflow = "hidden"; } }
  function closeDrawer() { if (drawer) { drawer.classList.remove("on"); if (scrim) scrim.classList.remove("on"); document.body.style.overflow = ""; } }
  window.closeCartDrawer = closeDrawer;

  function getCart() { return fetch(root + "cart.js", { headers: { "Content-Type": "application/json" } }).then(function (r) { return r.json(); }); }

  function renderDrawer(cart) {
    if (!drawer) return;
    var countEls = document.querySelectorAll(".cart-count");
    countEls.forEach(function (c) { c.textContent = cart.item_count; c.style.display = cart.item_count > 0 ? "" : "none"; });
    var dc = drawer.querySelector(".dh-count"); if (dc) dc.textContent = cart.item_count;

    var body = drawer.querySelector("[data-drawer-body]");
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML =
        '<div class="cart-empty">' +
        '<div class="empty-mark">' + (T.iconCart || "") + '</div>' +
        '<h3>Your cart is feeling light</h3>' +
        '<p>Add a little something from the bazaar.</p>' +
        '<a class="btn btn--dark" href="' + root + 'collections/all">Start shopping</a>' +
        '</div>';
      return;
    }

    var lines = cart.items.map(function (it, i) {
      var img = it.image ? '<img class="media-img" src="' + it.image.replace(/(\.[^.]+)(\?|$)/, "_160x$1$2") + '" alt="' + it.product_title + '">' : '<div class="tile"></div>';
      return '' +
        '<div class="cart-line" data-line="' + (i + 1) + '">' +
          '<div class="cl-media">' + img + '</div>' +
          '<div class="cl-body">' +
            '<div class="cl-top"><div>' +
              '<div class="cl-cat">' + (it.product_type || it.vendor || "") + '</div>' +
              '<div class="cl-name">' + it.product_title + '</div>' +
            '</div>' +
            '<button class="cl-remove" data-line-remove="' + (i + 1) + '" aria-label="Remove">' + (T.iconClose || "&times;") + '</button>' +
            '</div>' +
            '<div class="cl-bottom">' +
              '<div class="qty sm">' +
                '<button data-line-dec="' + (i + 1) + '" aria-label="Decrease">' + (T.iconMinus || "&minus;") + '</button>' +
                '<input type="text" inputmode="numeric" value="' + it.quantity + '" data-line-input="' + (i + 1) + '" aria-label="Quantity">' +
                '<button data-line-inc="' + (i + 1) + '" aria-label="Increase">' + (T.iconPlus || "+") + '</button>' +
              '</div>' +
              '<span class="cl-price">' + formatMoney(it.final_line_price) + '</span>' +
            '</div>' +
          '</div>' +
        '</div>';
    }).join("");

    var threshold = (T.freeShip || 0) * 100;
    var meter = "";
    if (T.freeShipMeter && threshold > 0) {
      var toFree = Math.max(0, threshold - cart.total_price);
      var pct = Math.min(100, (cart.total_price / threshold) * 100);
      meter =
        '<div class="ship-meter">' +
          '<span>' + (toFree > 0 ? 'Add <strong>' + formatMoney(toFree) + '</strong> more for <strong>free shipping</strong>' : (T.iconCheck || "") + ' You&#8217;ve unlocked <strong>free shipping</strong>') + '</span>' +
          '<span class="meter-track"><span class="meter-fill" style="width:' + pct + '%"></span></span>' +
        '</div>';
    }

    body.innerHTML =
      meter +
      '<div class="cart-lines">' + lines + '</div>' +
      '<div class="cart-foot">' +
        '<div class="sum-row"><span>Subtotal</span><span>' + formatMoney(cart.items_subtotal_price) + '</span></div>' +
        '<div class="sum-row total"><span>Total</span><span>' + formatMoney(cart.total_price) + '</span></div>' +
        '<a class="btn btn--primary lg full" href="' + root + 'checkout">Checkout &middot; ' + formatMoney(cart.total_price) + '</a>' +
        '<div class="cart-pay">' + (T.iconShield || "") + ' Secure checkout &middot; UPI, cards, COD</div>' +
      '</div>';
  }

  function refreshCart(open) {
    return getCart().then(function (cart) { renderDrawer(cart); if (open && useDrawer) openDrawer(); return cart; });
  }
  refreshCart(false);

  function addToCart(id, qty, name) {
    return fetch(root + "cart/add.js", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    }).then(function (r) { return r.json(); }).then(function () {
      if (name) showToast(name);
      return refreshCart(useDrawer);
    });
  }
  function changeLine(line, qty) {
    return fetch(root + "cart/change.js", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) { renderDrawer(cart); return cart; });
  }

  /* events */
  document.addEventListener("click", function (e) {
    var open = e.target.closest("[data-cart-open]");
    if (open) { e.preventDefault(); if (useDrawer) { refreshCart(true); } else { window.location.href = root + "cart"; } return; }
    if (e.target.closest("[data-cart-close]") || e.target === scrim) { closeDrawer(); return; }

    var qa = e.target.closest("[data-quick-add]");
    if (qa) { e.preventDefault(); e.stopPropagation(); addToCart(qa.getAttribute("data-quick-add"), 1, qa.getAttribute("data-title")); return; }

    var inc = e.target.closest("[data-line-inc]"); if (inc) { var li = +inc.getAttribute("data-line-inc"); var inp = drawer.querySelector('[data-line-input="' + li + '"]'); changeLine(li, (+inp.value) + 1); return; }
    var dec = e.target.closest("[data-line-dec]"); if (dec) { var ld = +dec.getAttribute("data-line-dec"); var ind = drawer.querySelector('[data-line-input="' + ld + '"]'); changeLine(ld, Math.max(0, (+ind.value) - 1)); return; }
    var rm = e.target.closest("[data-line-remove]"); if (rm) { changeLine(+rm.getAttribute("data-line-remove"), 0); return; }
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeDrawer(); });

  /* ---------- product form ---------- */
  var pform = document.getElementById("product-form");
  if (pform) {
    pform.addEventListener("submit", function (e) {
      e.preventDefault();
      var idInput = pform.querySelector('[name="id"]');
      var qtyInput = pform.querySelector('[name="quantity"]');
      var title = pform.getAttribute("data-title");
      addToCart(idInput.value, qtyInput ? +qtyInput.value : 1, title);
    });

    var buyNowBtn = pform.querySelector("[data-buy-now]");
    if (buyNowBtn) {
      buyNowBtn.addEventListener("click", function () {
        if (buyNowBtn.disabled) return;
        var idInput = pform.querySelector('[name="id"]');
        var qtyInput = pform.querySelector('[name="quantity"]');
        buyNowBtn.disabled = true;
        fetch(root + "cart/add.js", {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: idInput.value, quantity: qtyInput ? +qtyInput.value : 1 })
        }).then(function (r) { return r.json(); })
          .then(function () { window.location.href = root + "checkout"; })
          .catch(function () { buyNowBtn.disabled = false; });
      });
    }
  }

  /* qty steppers (PDP) */
  document.addEventListener("click", function (e) {
    var p = e.target.closest("[data-qty-plus]"); var m = e.target.closest("[data-qty-minus]");
    if (!p && !m) return;
    var wrap = (p || m).closest(".qty"); var inp = wrap.querySelector("input");
    var v = Math.max(1, (+inp.value || 1) + (p ? 1 : -1)); inp.value = v;
  });

  /* ---------- PDP tabs ---------- */
  document.addEventListener("click", function (e) {
    var tab = e.target.closest("[data-tab]");
    if (!tab) return;
    var key = tab.getAttribute("data-tab");
    var scope = tab.closest(".pdp-tabs");
    scope.querySelectorAll("[data-tab]").forEach(function (b) { b.classList.toggle("on", b === tab); });
    scope.querySelectorAll("[data-panel]").forEach(function (pn) { pn.classList.toggle("on", pn.getAttribute("data-panel") === key); });
  });

  /* ---------- PDP gallery ---------- */
  document.addEventListener("click", function (e) {
    var th = e.target.closest("[data-thumb]");
    if (!th) return;
    var gallery = th.closest(".pdp-gallery");
    var idx = th.getAttribute("data-thumb");
    var heroImg = gallery.querySelector("[data-gallery-main]");
    var src = th.getAttribute("data-src");
    if (heroImg && src) heroImg.src = src;
    gallery.querySelectorAll("[data-thumb]").forEach(function (t) { t.classList.toggle("on", t === th); });
  });

  /* ---------- PDP variants ---------- */
  var variantData = window.__variants;
  function selectVariant(id) {
    if (!variantData) return;
    var v = variantData.find(function (x) { return String(x.id) === String(id); });
    if (!v) return;
    var idInput = document.querySelector('#product-form [name="id"]'); if (idInput) idInput.value = v.id;
    var priceNow = document.querySelector("[data-price-now]"); if (priceNow) priceNow.innerHTML = formatMoney(v.price);
    var btn = document.querySelector("[data-add-text]");
    if (btn) btn.innerHTML = v.available ? "Add to cart &middot; " + formatMoney(v.price) : "Sold out";
    var addBtn = document.getElementById("add-btn"); if (addBtn) addBtn.disabled = !v.available;
    var buyBtn = document.getElementById("buy-now-btn"); if (buyBtn) buyBtn.disabled = !v.available;
  }
  document.addEventListener("change", function (e) {
    var s = e.target.closest("[data-variant-radio]");
    if (s) selectVariant(s.value);
  });
  document.addEventListener("click", function (e) {
    var sw = e.target.closest("[data-variant-swatch]");
    if (!sw) return;
    document.querySelectorAll("[data-variant-swatch]").forEach(function (x) { x.classList.toggle("on", x === sw); });
    var radio = document.querySelector('[data-variant-radio][value="' + sw.getAttribute("data-variant-swatch") + '"]');
    if (radio) { radio.checked = true; }
    selectVariant(sw.getAttribute("data-variant-swatch"));
  });
})();

/* ---------- interactive 3D tilt (product cards) ---------- */
(function () {
  "use strict";
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var finePointer = window.matchMedia("(pointer: fine)").matches;
  if (reduceMotion || !finePointer) return;

  var TILT_STRENGTH = 7; // degrees at the edge of the card
  var raf = null;

  function attachTilt(el) {
    var rect = null;
    function onEnter() { rect = el.getBoundingClientRect(); }
    function onMove(e) {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        if (!rect) rect = el.getBoundingClientRect();
        var px = (e.clientX - rect.left) / rect.width - 0.5;
        var py = (e.clientY - rect.top) / rect.height - 0.5;
        var rx = (-py * TILT_STRENGTH).toFixed(2);
        var ry = (px * TILT_STRENGTH).toFixed(2);
        el.style.transform = "rotateX(" + rx + "deg) rotateY(" + ry + "deg) translateY(-6px)";
      });
    }
    function onLeave() {
      if (raf) { cancelAnimationFrame(raf); raf = null; }
      el.style.transform = "";
    }
    el.addEventListener("pointerenter", onEnter);
    el.addEventListener("pointermove", onMove);
    el.addEventListener("pointerleave", onLeave);
  }

  function initTilt() {
    document.querySelectorAll(".pcard-media").forEach(function (el) {
      if (el.__tiltBound) return;
      el.__tiltBound = true;
      attachTilt(el);
    });
  }

  initTilt();
  // Re-scan after dynamic content (e.g. quick-view, infinite scroll, cart drawer swaps) settles.
  if ("MutationObserver" in window) {
    var mo = new MutationObserver(function () { initTilt(); });
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();
